import React, { useEffect, useState } from "react";
import OrderTrackCard from "../order-track-card";
import { UserTrackDetails } from "../../../api/methods-marketplace";
import TrackAssetLoader from "./TrackAssetLoader";

const TrackAssetTabs = () => {
  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchShipmentDetails = async () => {
      try {
        setLoading(true);
        const response = await UserTrackDetails();
        setShipments(response?.data);
        setError(null);
      } catch (err) {
        console.error("Error fetching shipment details:", err);
        setError("Failed to load shipment details");
      } finally {
        setLoading(false);
      }
    };

    fetchShipmentDetails();
  }, []);

  if (loading) {
    return <TrackAssetLoader />;
  }

  if (error) {
    return (
      <div className="flex justify-center items-center p-8">
        <p className="text-red-600">{error}</p>
      </div>
    );
  }

  if (!shipments || shipments.length === 0) {
    return (
      <div className="flex gap-2 my-6 p-4 border border-[#C2C2C2] rounded-2xl">
        <div className={`w-full flex flex-col gap-6`}>
          <div className="flex justify-center items-center p-8">
            <p className="text-gray-700">No shipment details available</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex gap-2 my-6 p-4 border border-[#C2C2C2] rounded-2xl">
        <div className={`w-full flex flex-col gap-6`}>
          {shipments.map((shipment, index) => (
            <div
              key={shipment.collection.id || index}
              className="flex gap-6 flex-col lg:flex-row lg:items-center"
            >
              <div className="flex items-center gap-4 lg:max-w-md xl:max-w-lg">
                <div className="c-image flex-shrink-0">
                  <img
                    src={`https://ipfs.io/ipfs/${shipment.collection.image_hash}`}
                    className="w-[5rem] h-[5rem] sm:w-[6rem] sm:h-[6rem] rounded-xl object-cover"
                    alt={shipment.collection.name || "Product"}
                    // onError={(e) => {
                    //   e.target.src = imgSrc;
                    // }}
                  />
                </div>
                <h2
                  className="m-0 text-base leading-2 text-black truncate max-w-[200px] sm:max-w-[100px] lg:max-w-[150px]"
                  title={shipment.collection.name}
                >
                  {shipment.collection.name}
                </h2>
              </div>
              <OrderTrackCard
                collectionData={shipment}
                orderStatus={shipment.status}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TrackAssetTabs;
